export const ProductLabel = {
  ProductTitle: "Product",
  NewProduct: "New Product",
  ViewProduct: "View Product",
  EditProduct: "Edit Product",
  AddProduct: "Add Product",
  ProductCode: "Product Code",
  BatchNo: "Batch No.",
  Quantity: "Quantity",
  MinimumQuantity: "Minimum Quantity",
  Rate: "Rate",
  ProductDescription: "Product Description",
  Images: "Images",
  Image: "Image",
  MaterialType: "Material Types",
  Condition: "Condition",
  MaterialGroup: "Material Group",
  MaterialGroupDescription: "Ext.Material Description",
  Make: "Make",
  Amount: "Amount",
  UOM: "UOM",
  RakeNo: "Rake No.",
  Specifications: "Specifications",
  Remark: "Remark",
  ReturnableItem: "Returnable Item",
  PrimaryDetails: "Primary Details",
  History: "History",
  Overview: "Overview",
  Date: "Date",
  Details: "Details",
  DateDetails: "03/09/2021 04:05 PM",
  CreatedDetails: "created by - admin",
  Require: "*",
  DragAndDrop: "Drag & drop images here, or click to select files",
  MinimumQuantityValidation: "Minimum quantity should be less than quantity",
  ImportProduct: "Import Product",
  OnlyExcelAllowed:"Only Excel Files (.xlsx, .xls) Allowed",
  selectFileToUpload:"Please select a file to upload",
  clickHereToSeeSampleFile:"Click here to download sample file",
  importExcelFile:"Import Excel File"

};
export const ConditionOptions = [
  { label: "New", value: "New" },
  { label: "Refurbished", value: "Refurbished" },
  { label: "Damaged", value: "Damaged" },
];
export const UomValueOptions = [
  { label: "Nos", value: "Nos" },
  { label: "Set", value: "Set" },
  { label: "Itr", value: "Itr" },
  { label: "Pcs", value: "Pcs" },
];
export const RakeNoOptions = [
  { label: "Option 1", value: "Option 1" },
  { label: "Option 2", value: "Option 2" },
  { label: "Option 3", value: "Option 3" },
];
export const ProductKey = {
  ProductCode: "product.product_code",
  BatchNo: "batch_no",
  Quantity: "quantity",
  MinimumQuantity: "product.minimum_quantity",
  Rate: "rate",
};
